export default "__VITE_ASSET__BGATsjOJ__"